import axios from 'axios'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Container, OverlayTrigger, Tooltip, Modal, Card } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { GrClear } from 'react-icons/gr'
import { formatearNumero } from '../../../../common/Formatos'
import { obtenerGrillaHistorialGastos, postAnularGato } from '../../../../store/actions/proceso-judicial-action'
import { LoadingComponent } from 'recupero-comunes'
import { verDocumento } from '../../../../api/api-proceso-judicial';

const Acciones = ({handleClose,handleShowToastAnular,handleCloseGastos,setIsLimpiar,listaGrilla,setListaGrilla}) => {
const [loading, setLoading]=useState(false)  
const [gasto, setGasto] = useState('')
const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
const {llaves} = data_recepciona
const data_modal_contacto = useSelector((state) => state.procesoJudicialReducer)
const { cfg_form22, grillaHistorialGastos} = data_modal_contacto
const [showModalError, setShowModalError] = useState(false);
const [glosaError, setGlosaError] = useState("");
  
const dispatch = useDispatch()
  
useEffect(()=>{
  setListaGrilla(grillaHistorialGastos && grillaHistorialGastos.grillaHistorialGastos)
},[grillaHistorialGastos])

const handleAnular=(row)=>{
  const dataForm={}
  dataForm['idCaso'] = llaves && llaves['idCaso']
  dataForm['idImplicadoCaso'] = llaves && llaves['idImplicado']
  dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso']
  dataForm['idUsuario'] = llaves && llaves['idUsuario']
  dataForm['secuencia'] = row['secProvision']
  
  if(llaves){

    let query = Buffer.from(
    JSON.stringify({"idCaso": llaves && llaves["idCaso"],
    "idImplicado": llaves && llaves["idImplicado"],
    })
    ).toString('base64')
    dispatch(postAnularGato(dataForm)).then(()=>handleHistorial())
    handleShowToastAnular()
  }
}
 const handleHistorial=()=>{
 
    if(llaves){
      let query = Buffer.from(
        JSON.stringify({"idCaso": llaves && llaves["idCaso"],
        "idImplicado": llaves && llaves["idImplicado"],
       })
      ).toString('base64')
       dispatch(obtenerGrillaHistorialGastos(query))
    }
 }
 const handleLimpiar =()=>{
  setListaGrilla('')
  setIsLimpiar(true)
 }
 const handleVerDocumento = async (row) => {
  setLoading(true);
  let query = Buffer.from(JSON.stringify({
      idCaso: llaves.idCaso,
      idImplicadoCaso: llaves.idImplicado,
      idCompania: llaves.idOrgCaso,
      idfolioCarga: row.idfolioCargaDocto ? row.idfolioCargaDocto : 0
  })).toString('base64')

  try {
    
    const response = await verDocumento(query);
    var link = document.createElement("a");
    link.download = response.filename;
    link.href = "data:" + response.mimetype + ";base64," + response.file;
    link.click();
    setLoading(false);

  } catch(error) {
    setGlosaError(error.message);
    setShowModalError(true)
    setLoading(false);
  }
}
 const obtenerColumnas = () => {
  return [
    {
      dataField: 'glosaTipoGasto',
      text:cfg_form22 && cfg_form22.cfg_form22[
        'modal-gastos-grilla-tipogasto'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'glosaCobertura',
      text:cfg_form22 && cfg_form22.cfg_form22[
        'modal-gastos-grilla-cobertura'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'fechaOcurrenciaFormat',
      text: cfg_form22 && cfg_form22.cfg_form22[
        'modal-gastos-grilla-fechaocurre'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'glosaMoneda',
      text: cfg_form22 && cfg_form22.cfg_form22[
        'modal-gastos-grilla-moneda'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
    {
      dataField: 'montoProvision',
      text:cfg_form22 && cfg_form22.cfg_form22[
        'modal-gastos-grilla-monto'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      },
      formatter: (cell, row) => (formatearNumero(cell, !cell.codMoneda == 30001))
    },
    {
      dataField: 'comentario',
      text:cfg_form22 && cfg_form22.cfg_form22[
        'modal-gastos-input-comentario'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle',
        width:'15%'
      },
      formatter:(cell, row)=>{
        if(cell?.length>18) {
          return <>        
              <a href='#' style={{textDecoration:'none'}} onClick={(e)=>{
                 e.preventDefault()
                alert(cell)}}>{cell.substring(0,18)}</a>
                
          </>
         }else{
             return cell
         }
       }
    },
    {
      dataField: 'usuario',
      text:cfg_form22 && cfg_form22.cfg_form22[
        'modal-gastos-grilla-usuario'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    {
      dataField: 'fechaIngresoFormat',
      text:cfg_form22 && cfg_form22.cfg_form22[
        'modal-gastos-grilla-fecharegistro'
      ],
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
    {
      dataField: 'opciones',
      text: '',
      isDummyField: true,
      headerStyle: (colum, colIndex) => {
        return {
         
          textAlign: 'center',
          verticalAlign: 'center',
          backgroundColor: '#728bb0',
          color: 'white'
        }
      },
      style: { textAlign: 'center', verticalAlign: 'middle' },
      text: 'Ver Docto',
      formatter: (cell, row) => (
        
       <div>
          {
          parseInt(row.idfolioCargaDocto) > 0  ? ( <OverlayTrigger
            overlay={<Tooltip id='tooltip-disabled'>Detalles </Tooltip>}
          >
            <Button
              type='button'
              variant='outline-secondary me-md-2'
              size='sm'
              onClick={() => handleVerDocumento(row)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        </svg>
            </Button>
          </OverlayTrigger>):null
          
          }
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'anular',
      text: 'Anular',
      isDummyField: true,
      headerStyle: (colum, colIndex) => {
        return {
         
          textAlign: 'center',
          verticalAlign: 'center',
          backgroundColor: '#728bb0',
          color: 'white'
        }
      },
      style: { textAlign: 'center', verticalAlign: 'middle' },
      formatter: (cell, row) => (
        
       <div>
           <OverlayTrigger
            overlay={<Tooltip id='tooltip-disabled'>Anular </Tooltip>}
          >
            <Button
              type='button'
              variant='subir me-md-2'
              size='sm'
              onClick={() => handleAnular(row)}
            >
             <GrClear size={25} style={{ color: 'white' }}/>
            </Button>
          </OverlayTrigger>
          
          
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    }
  ]
}
const handleShow=(row)=>{
  if(row.tipoGasto===244010){
    setGasto('Honorario')
  }else{
    setGasto('Gasto')
  }
  handleShowCarpeta()
}
  return (
    <>
      <style type='text/css'>
        {`
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-cambiar {
      background-color:  #286FBF;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-cambiar:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    .btn-recepcionar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-recepcionar:hover{
        background-color: #F6897E;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }
   

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    `}
      </style>
      <LoadingComponent show={loading}/>      
      <Modal show={showModalError} onHide={() => setShowModalError(false)} size='md'>
          <Card>
              <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                  Información Respuesta
              </Card.Header>

              <Card.Body>
                  {glosaError}
              </Card.Body>

              <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModalError(false)}>Cerrar</Button>
              </Card.Footer>
          </Card>
      </Modal>
      <Container>
      <Row>
         
        <Col className='d-flex align-items-end justify-content-end m-2'>
          <Button className='m-2 w-auto' variant='outline-info' onClick={handleCloseGastos}   >
          {cfg_form22 && cfg_form22.cfg_form22["modal-gastos-btn-cerrar"]}
          </Button>
          <Button className='m-2' variant='bitacora' onClick={handleHistorial} >
          {cfg_form22 && cfg_form22.cfg_form22["modal-gastos-btn-historial"]}
          </Button>
          <Button className='m-2' variant='carpeta' onClick={handleLimpiar} >
          {cfg_form22 && cfg_form22.cfg_form22["modal-gastos-btn-limpiar"]}
          </Button>
          <Button
            className='m-2'
            variant='actualizar'
            type='onSubmit'
           
          
            name='actualizar'
          >
            {cfg_form22 && cfg_form22.cfg_form22["modal-gastos-btn-ingresar"]}
          </Button>
          
        </Col>
      </Row>
      <Row className='mt-4 mb-3'>
          <Col>
            <ToolkitProvider
                search
                bootstrap4
                keyField='secProvision'
                data={listaGrilla ? listaGrilla : []}
                columns={obtenerColumnas()}
                defaultSorted={[{ dataField: 'fechaIngresoFormat', order: 'asc' }]}
               
                >
                {(props) => (
                    <div>
                   

                    <BootstrapTable
                        {...props.baseProps}
                        bordered={false}
                        headerWrapperClasses='table-secondary'
                        pagination={paginationFactory({ sizePerPage: 5})}
                        noDataIndication={
                        <div className='text-center'>
                            No hay registros encontrados
                        </div>
                        }
                    />
                    </div>
                )}
            </ToolkitProvider>
          </Col>
      </Row>
      </Container>
    </>
  )
}

export default Acciones
